import api from "Helpers/Api";
import { BannersListResponse } from "Services/Banners/banner";

export default async function bannersList() {
  const { data } = await api.get<BannersListResponse>(`/banners`);
  return data;
}
